import React from 'react';

const HeroSection = () => {
  return (
    <>
      <style jsx>{`
        .hero-section {
          background: #ffffff;
          padding: 80px 40px;
          min-height: 500px;
          display: flex;
          align-items: center;
          position: relative;
          overflow: hidden;
        }

        .hero-section::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: linear-gradient(135deg, rgba(33, 150, 243, 0.02) 0%, rgba(25, 118, 210, 0.02) 100%);
          z-index: 1;
        }

        .hero-container {
          max-width: 1200px;
          margin: 0 auto;
          width: 100%;
          position: relative;
          z-index: 2;
        }

        .hero-content-10 {
          text-align: left;
          animation: fadeInUp 0.8s ease-out;
        }

        .hero-title {
          font-size: 3.5rem;
          font-weight: 700;
          color: #0099DA;
          line-height: 1.2;
          margin: 0 0 30px 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          position: relative;
          padding-left: 70px;
          animation: slideInLeft 1s ease-out;
        }

        .hero-title::before {
          content: '🔧';
          position: absolute;
          left: 0;
          top: 5px;
          font-size: 3rem;
          color: #8a8a8a;
          animation: bounce 2s ease-in-out infinite;
        }

        @keyframes bounce {
          0%, 20%, 50%, 80%, 100% {
            transform: translateY(0);
          }
          40% {
            transform: translateY(-10px);
          }
          60% {
            transform: translateY(-5px);
          }
        }

        .hero-subtitle {
          font-size: 1.5rem;
          color: #333;
          line-height: 1.4;
          margin: 0 0 50px 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          font-weight: 400;
          padding-left: 70px;
          animation: slideInLeft 1s ease-out 0.2s both;
        }

        .partnership-wrapper {
          display: flex;
          align-items: center;
          gap: 60px;
          padding-left: 70px;
          animation: slideInLeft 1s ease-out 0.4s both;
        }

        .partnership-text-1 {
          font-size: 2.5rem;
          color: #0099DA;
          font-weight: 600;
          margin: 0;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          line-height: 1.3;
          flex: 1;
          max-width: 40%;
        }

        .shell-logo-container {
          display: flex;
          align-items: center;
          justify-content: center;
          flex: 1;
        }

        .shell-helix-logo {
          width: 100%;
          max-width: 600px;
          height: auto;
          object-fit: contain;
          animation: fadeInRight 1s ease-out 0.6s both;
        }

        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(30px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        @keyframes slideInLeft {
          from {
            opacity: 0;
            transform: translateX(-50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @keyframes fadeInRight {
          from {
            opacity: 0;
            transform: translateX(50px);
          }
          to {
            opacity: 1;
            transform: translateX(0);
          }
        }

        @media (max-width: 1024px) {
          .hero-title {
            font-size: 2.8rem;
            padding-left: 60px;
          }

          .hero-title::before {
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1.3rem;
            padding-left: 60px;
          }

          .partnership-wrapper {
            flex-direction: column;
            align-items: flex-start;
            gap: 30px;
            padding-left: 60px;
          }

          .partnership-text-1 {
            font-size: 2.5rem;
            min-width: auto;
          }

          .shell-helix-logo {
            max-width: 350px;
          }
        }

        @media (max-width: 768px) {
          .hero-section {
            padding: 60px 20px;
            min-height: 400px;
          }

          .hero-title {
            font-size: 2.2rem;
            padding-left: 50px;
            line-height: 1.3;
          }

          .hero-title::before {
            font-size: 2rem;
            top: 2px;
          }

          .hero-subtitle {
            font-size: 1.1rem;
            padding-left: 50px;
            margin-bottom: 40px;
          }

          .partnership-wrapper {
            padding-left: 50px;
            gap: 25px;
          }

          .partnership-text-1 {
            font-size: 2rem;
          }

          .shell-helix-logo {
            max-width: 200px;
          }
        }

        @media (max-width: 600px) {
          .hero-section {
            padding: 40px 15px;
          }

          .hero-content-10 {
            text-align: center;
          }

          .hero-title {
            font-size: 1.8rem;
            padding-left: 0;
            text-align: center;
          }

          .hero-title::before {
            position: static;
            display: block;
            margin: 0 auto 15px;
            font-size: 2.5rem;
          }

          .hero-subtitle {
            font-size: 1rem;
            padding-left: 0;
            margin-bottom: 30px;
            text-align: center;
          }

          .partnership-wrapper {
            padding-left: 0;
            flex-direction: column;
            align-items: center;
            gap: 20px;
            text-align: center;
          }

          .partnership-text-1 {
            font-size: 1.5rem;
            text-align: center;
          }

          .shell-logo-container {
            justify-content: center;
          }

          .shell-helix-logo {
            max-width: 180px;
          }
        }

        @media (max-width: 480px) {
          .hero-section {
            padding: 30px 10px;
          }

          .hero-title {
            font-size: 1.6rem;
            line-height: 1.4;
          }

          .hero-title::before {
            font-size: 2rem;
            margin-bottom: 10px;
          }

          .hero-subtitle {
            font-size: 0.9rem;
            line-height: 1.5;
          }

          .partnership-text-1 {
            font-size: 1.3rem;
            line-height: 1.4;
          }

          .shell-helix-logo {
            max-width: 160px;
          }
        }

        /* SEO and Accessibility improvements */
        .sr-only {
          position: absolute;
          width: 1px;
          height: 1px;
          padding: 0;
          margin: -1px;
          overflow: hidden;
          clip: rect(0, 0, 0, 0);
          white-space: nowrap;
          border: 0;
        }

        .hero-section:focus-within {
          outline: none;
        }
      `}</style>

      <section 
        className="hero-section" 
        role="banner"
        aria-labelledby="hero-title"
        itemScope
        itemType="https://schema.org/AutoRepair"
      >
        <div className="hero-container">
          <div className="hero-content-10">
            <h1 
              id="hero-title"
              className="hero-title"
              itemProp="name"
            >
              <span className="sr-only">Faucon Bleu - </span>
              Votre entretien auto, où vous voulez<br />
              Quand vous voulez.
            </h1>
            
            <p 
              className="hero-subtitle"
              itemProp="description"
            >
              Vidange mobile, mécanique et carrosserie – par des pros de<br />
              confiance, partout à Casablanca.
            </p>

            <div className="partnership-wrapper">
              <p className="partnership-text-1">
                En partenariat officiel avec les huiles moteur
              </p>
              
              <div className="shell-logo-container">
                <img 
                  src="/images/oil_helix.png" 
                  alt="Shell Helix Ultra - Huiles moteur premium partenaire officiel Faucon Bleu" 
                  className="shell-helix-logo"
                  loading="eager"
                  width="300"
                  height="100"
                  itemProp="brand"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Structured Data for SEO */}
        <script 
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              "@context": "https://schema.org",
              "@type": "AutoRepair",
              "name": "Faucon Bleu",
              "description": "Service d'entretien automobile mobile à Casablanca - Vidange, mécanique et carrosserie à domicile",
              "url": "https://fauconbleu.ma",
              "telephone": "+212702094593",
              "address": {
                "@type": "PostalAddress",
                "addressLocality": "Casablanca",
                "addressCountry": "MA"
              },
              "serviceArea": {
                "@type": "GeoCircle",
                "geoMidpoint": {
                  "@type": "GeoCoordinates",
                  "latitude": 33.5731,
                  "longitude": -7.5898
                },
                "geoRadius": "50000"
              },
              "hasOfferCatalog": {
                "@type": "OfferCatalog",
                "name": "Services automobiles",
                "itemListElement": [
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Vidange mobile",
                      "description": "Service de vidange à domicile"
                    }
                  },
                  {
                    "@type": "Offer", 
                    "itemOffered": {
                      "@type": "Service",
                      "name": "Mécanique automobile",
                      "description": "Réparation et entretien mécanique"
                    }
                  },
                  {
                    "@type": "Offer",
                    "itemOffered": {
                      "@type": "Service", 
                      "name": "Carrosserie",
                      "description": "Réparation de carrosserie automobile"
                    }
                  }
                ]
              }
            })
          }}
        />
      </section>
    </>
  );
};

export default HeroSection;